export default class ExamEvaluation {
  readonly id: number
  readonly value: string
  readonly from: number
  readonly to: number
  readonly body: string
  readonly description: string
  readonly kind: string

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.value = data.value
    this.from = data.from
    this.to = data.to
    this.body = data.body
    this.description = data.description
    this.kind = data.kind
  }
}
